export default function searchReducer(_, action) {
  const { data } = action;
  switch (action.type) {
    case 'init':
      return { items: data || [] };
    default:
      throw new Error('Invalid action type')
  }
}
